import { createMachine } from 'xstate';
import { actions } from './actions.js';

var selectableStateMachine = createMachine({
    predictableActionArguments: true,
    id: "select",
    initial: "idle",
    on: {
        click: {
            actions: [
                "setActiveOption",
                "toggleActiveSelected",
                "onSelectCallback",
            ],
        },
        mouseenter: { actions: "setActiveOption" },
        mouseleave: { actions: "unsetActiveOption" },
        toggleOptionSelection: { actions: ["toggleOptionSelection"] },
        setOptions: { actions: ["setOptions", "setDefaultActiveOptionDown"] },
    },
    states: {
        idle: {
            on: {
                FOCUS: {
                    actions: ["setDefaultActiveOptionDown"],
                    target: "active",
                },
                KEYBOARD_FOCUS: {
                    actions: ["setDefaultActiveOptionDown", "onActiveChanged"],
                    target: "active",
                },
            },
        },
        active: {
            on: {
                BLUR: { target: "idle" },
                keyDownArrowDown: { actions: ["moveActiveDown", "onActiveChanged"] },
                keyDownArrowUp: { actions: ["moveActiveUp", "onActiveChanged"] },
                keyDownEnd: { actions: ["moveActiveToLast", "onActiveChanged"] },
                keyDownHome: { actions: ["moveActiveToFirst", "onActiveChanged"] },
                keyDownSpace: {
                    actions: ["toggleActiveSelected", "onSelectCallback"],
                },
                // KEY_DOWN_ENTER: [{ target: "idle", actions: ["makeActiveSelected"] }],
                keyDownEnter: [
                    { actions: ["makeActiveSelected", "onSelectCallback"] },
                ],
                keyDownEscape: { target: "idle", actions: ["focusOnTrigger"] },
                keyDownTab: { target: "idle" },
            },
        },
    },
}, 
// use single select actions by default
// useSelectStateMachine will override where appropriate
{ actions: actions });

export { selectableStateMachine };
//# sourceMappingURL=stateMachine.js.map
